import { Contact, ContactType } from './contact';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Resource } from '@patterns/core';

@Resource('leasing_companies')
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class LeasingCompany extends Contact {
  constructor(data: any = {}) {
    super(data);
    this.type = ContactType.LEASING_COMPANY;
  }
}

